import gql from 'graphql-tag';

const GET_ORDER_WINDOWS = gql`
    query getOrderWindows ($filters: OrdersWindowInput) {
        getOrderWindows (filters: $filters) {
            internalCode
            payload {
                init
                end
                name
                id
                salesChannel
                courierId
                selectedSla
                courierName
            }
        }
    }
`;

export default GET_ORDER_WINDOWS;